import { get, isEmpty } from 'lodash'

const isLoading = state => get(state, 'vista360OrderDashboardLoad.loading')
const hasErrors = state => !isEmpty(get(state, 'vista360OrderDashboardLoad.error'))

export const selectors = {
  isLoading,
  hasErrors,
}
